type Severity = "info" | "warning" | "critical";

const SEV: Record<Severity, { wrap: string; icon: string }> = {
  info: {
    wrap: "border-sky-500/30 bg-sky-500/5 text-sky-200",
    icon: "ℹ",
  },
  warning: {
    wrap: "border-amber-500/30 bg-amber-500/5 text-amber-200",
    icon: "⚠",
  },
  critical: {
    wrap: "border-red-500/40 bg-red-500/10 text-red-200",
    icon: "✕",
  },
};

export type AlertItem = {
  severity: Severity;
  message: string;
  /** chave estável para evitar warning de key duplicada */
  key?: string;
};

export function AlertBanner({ alerts }: { alerts: ReadonlyArray<AlertItem> }) {
  if (alerts.length === 0) return null;
  return (
    <div className="space-y-1.5">
      {alerts.map((a, i) => {
        const s = SEV[a.severity];
        return (
          <div
            key={a.key ?? `${a.severity}-${i}`}
            className={`rounded-md border px-3 py-2 text-sm flex gap-2 items-start ${s.wrap}`}
          >
            <span className="font-mono text-xs mt-0.5">{s.icon}</span>
            <span className="flex-1">{a.message}</span>
          </div>
        );
      })}
    </div>
  );
}

/**
 * Converte warnings strings vindas do engine F5.4 em AlertItems classificados.
 * Mapeia keywords para severity. Falls back para "warning".
 */
export function engineWarningsToAlerts(
  warnings: ReadonlyArray<string> | null | undefined,
): AlertItem[] {
  if (!warnings || warnings.length === 0) return [];
  return warnings.map((w, i) => {
    const lower = w.toLowerCase();
    let severity: Severity = "warning";
    if (
      lower.includes("marge sur coûts variables") ||
      lower.includes("≤ 0") ||
      lower.includes("trésorerie ne correspond pas")
    ) {
      severity = "warning";
    }
    if (lower.includes("erreur") || lower.includes("erro")) {
      severity = "critical";
    }
    if (lower.includes("annualis") || lower.includes("anuali")) {
      severity = "info";
    }
    return {
      severity,
      message: w,
      key: `engine-${i}`,
    };
  });
}
